<template>
  <img
    class="object-contain w-full"
    :class="[
      $attrs.class ? $attrs.class : 'h-12'
    ]"
    alt="FPX logo"
    src="@/assets/image/fpx-logo.svg"
  />
</template>